export default __webpack_public_path__ + "static/edge-d284bcab7b1510592253c4fbd292fa38.svg";